var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#EFF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 23V27M30 21V25M29 16C31.4487 16 32.7731 16.3748 33.4321 16.6654C33.5199 16.7042 33.5638 16.7235 33.6904 16.8444C33.7663 16.9168 33.9049 17.1294 33.9405 17.2281C34 17.3927 34 17.4827 34 17.6627V28.4111C34 29.3199 34 29.7743 33.8637 30.0079C33.7251 30.2454 33.5914 30.3559 33.3319 30.4472C33.0769 30.5369 32.562 30.438 31.5322 30.2401C30.8114 30.1017 29.9565 30 29 30C26 30 23 32 19 32C16.5513 32 15.2269 31.6252 14.5679 31.3346C14.4801 31.2958 14.4362 31.2765 14.3096 31.1556C14.2337 31.0832 14.0951 30.8706 14.0595 30.7719C14 30.6073 14 30.5173 14 30.3373L14 19.5889C14 18.6801 14 18.2257 14.1363 17.9921C14.2749 17.7546 14.4086 17.6441 14.6681 17.5528C14.9231 17.4631 15.438 17.562 16.4678 17.7598C17.1886 17.8983 18.0435 18 19 18C22 18 25 16 29 16ZM26.5 24C26.5 25.3807 25.3807 26.5 24 26.5C22.6193 26.5 21.5 25.3807 21.5 24C21.5 22.6193 22.6193 21.5 24 21.5C25.3807 21.5 26.5 22.6193 26.5 24Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.58aa441b8b83767880de8416d633d619.svg";
export { ForwardRef as ReactComponent };